import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';
import { environments } from './environments';
import fetch from 'cross-fetch';

const createGraphClient = () => {
  return new ApolloClient({
    link: new HttpLink({
      uri: environments.graphQL,
      fetch,
    }),
    cache: new InMemoryCache(),
  });
};

export const apolloClientInstance = createGraphClient();
export { ApolloProvider } from '@apollo/client';